import React from 'react';
import SMRoomInquiryView from './SMRoomInquiryView';
import SMRoomCarouselView from './SMRoomCarouselView';
import SMRoomInquiryFormView from './SMRoomInquiryFormView';
import SMSlidePhotoView from './SMSlidePhotoView';
import SMCoverPhotoView from './SMCoverPhotoView';
import SMUserContactView from 'components/users/SMUserContactView';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRoomResource from 'resources/SMRoomResource';
import SMUserResource from 'resources/SMUserResource';
import SMConst from 'lib/SMConst';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import sprintf from 'sprintf';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMOwnerHelper from 'components/helpers/SMOwnerHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMReputationListView from 'components/reputations/SMReputationListView';
import SMOwnerSummaryView from 'components/owners/SMOwnerSummaryView';
import SMSpaceMapView from 'components/spaces/SMSpaceMapView';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import OptimizedImage from 'components/shared/OptimizedImage';
import SMUFavoriteListSelectView from 'components/dashboard/users/SMUFavoriteListSelectView';
import Clipboard from 'clipboard';

class SMRoomView extends React.Component {

  constructor(props) {
    super(props);

    this.roomTag = {
       otherRooms: 0,
       recommendRooms: 1,
       browseRooms: 2,
     };

     this.scrollTab = {
       info: 0,
       price: 1,
       review: 2,
       access: 3,
       relation: 4,
     };

    const room = this.props.room;

    const tabIndex = (room.plans.length == 0 && room.rent_type == SMConst.RentType.Stay) ? 1 : 0;

    this.state = {
      room: room,
      browseRooms: [],
      areaRecommendRooms: [],
      isSlidePhotoOpen: false,
      selectedPhotoIndex: 0,
      isOpenShare: false,
      isOpenDefaultFavoriteList: false,
      fbUrl: "",
      twitterUrl: "",
      lineUrl: "",
      fbPageUrl: "",
      isInquiryViewOpen: false,
      isInquiryFormViewOpen: false,
      isContactViewOpen: false,
      isShowRoomDescriptionMore: false,
      isShowSpaceDescriptionMore: false,
      isSMUFavoriteListSelectViewOpen: false,
      isRoomAttentionPopupViewOpen: false,
      selectedTabIndex: tabIndex,
      documentImages: 0,
      currentTab: 0,
      targetFavoriteRoom: room,
      latestUpdatedFavoriteList: {},
      isOpenAmenities: false,
      isOpenAboutFood: false,
      isOpenAboutTrash: false,
      attentionWeeklyGuests: 0,
      wasShownUsage: false,
    };
  }

  componentDidMount() {

    const room = this.state.room;
    this.setState({
      fbUrl: SMAppHelper.shareRoomFacebookShareUrl(room),
      twitterUrl: sprintf("https://twitter.com/intent/tweet?url=%s&amp;text=%s&amp;url=%s",
        window.location.href,
        SMFormatHelper.roomName(room),
        window.location.href
      ),
      lineUrl: SMAppHelper.shareRoomLineUrl(room),
      copyUrl: window.location.href,
    });

    window.addEventListener('resize', this.resize.bind(this));
    window.addEventListener('scroll', this.onScroll.bind(this));
    SMTrackHelper.criteoItem(this.props.currentUser ? this.props.currentUser.email : "", this.props.room.uid);

    if ($(this.refs.roomExpandableArea).height() < $(this.refs.roomExpandableAreaText).height()) {
      this.setState({isShowRoomDescriptionMore: true});
    }
    if ($(this.refs.spaceExpandableArea).height() < $(this.refs.spaceExpandableAreaText).height()) {
      this.setState({isShowSpaceDescriptionMore: true});
    }

    // 周辺のおすすめスペースを取得
    this.requestAreaRecommendRooms();
    // 閲覧履歴
    this.requestBrowserHistories();
    this.requestattentionWeeklyGuests();
    this.setStickyContent();

    this.clipboard = new Clipboard(this.refs.urlCopy);
    this.clipboard.on('success', (e) => {
      e.clearSelection();

      // Copied Animation
      if (e.text) {
        const elem = e.trigger;
        elem.setAttribute('aria-label', "コピーしました");
        setTimeout(function() {
          elem.setAttribute('aria-label', "");
        }, 1000);
      }

      SMTrackHelper.pageEvent("room copy_url");
    });

    this.setState({
      isRoomAttentionPopupViewOpen: true,
    });
    setTimeout(() => {
      this.setState({
        isRoomAttentionPopupViewOpen: false,
      });
    }, 18000);
  }

  componentDidUpdate(prevProps, prevState) {
  }

  componentWillUnmount() {
    this.clipboard.destroy();
    this.clipboard = null;
  }

  requestBrowserHistories() {
    let q = {page: 1, per_page: 10};
    SMUserResource.getBrowseHistories(this.props.currentUser, q, (rooms, error, xhr)=>{
      this.setState({
        browseRooms: rooms
      });
      setTimeout(()=>{
        this.setStickyContent();
      }, 1);
    });
  }

  requestAreaRecommendRooms() {

    const room = this.props.room;
    const queries = {
      page: 1,
      per_page: 6,
      exclude_room_id: room.id,
      geocode: [room.space.latitude, room.space.longitude, '1km'].join(','),
    };
    SMRoomResource.search(queries, (responses, error, xhr)=>{
      if(error || !responses) return;
      const rooms = responses || room.recommends;
      this.setState({
        areaRecommendRooms: rooms,
      });
      setTimeout(()=>{
        this.setStickyContent();
      }, 1);

      rooms.forEach((room, index) => {
        ga('ec:addImpression', {
          id: room.id,
          category: `${room.space.country_alpha2}/${room.space.state}/${room.space.space_type}`,
          brand: room.owner.id,
          list: 'SearchList',
          position: (this.state.currentPage - 1) * this.props.perPage + index,
          dimension1: 'Room'
        });
      });
      ga('send', 'event', 'Ecommerce', 'addImpression', {'nonInteraction': 1});
    });
  }

  requestattentionWeeklyGuests() {
    const room = this.props.room;
    SMUserResource.getAttentionWeeklyGuests(room.uid, (responses, error, xhr)=>{
      if (xhr.status === 200) {
        this.setState({
          attentionWeeklyGuests: responses.weekly_guests
        });
      }
    });
  }

  setStickyContent() {
    if (!SMAppHelper.isMobile()) {
      $(this.refs.spaceSide).sticky({
        topSpacing:72,
        bottomSpacing: $("body").height() - $(this.refs.stickyByBottom).offset().top + 24
      });

      $(this.refs.headerTab).sticky({
        bottomSpacing: $("body").height() - $(this.refs.stickyheaderByBottom).offset().top
      });
    } else {
      $(this.refs.headerTab).sticky({
        topSpacing:58,
        bottomSpacing: $("body").height() - $(this.refs.stickyheaderByBottom).offset().top
      });
    }
  }

  renderVr(room) {
    if (!room.embed_vr_url) {
      return null;
    }

    return (
      <div className="even-col__line clearfix">
        <div className="col-lg-12">
          <h2 className="space-main__headline space-main__headline-col12">バーチャル内覧</h2>
        </div>
        <div className="col-xs-12 space-main__vr">
          <iframe src={room.embed_vr_url} allowFullScreen></iframe>
        </div>
      </div>
    );
  }

  renderVideo(room) {
    if (!room.embed_video_url) {
      return null;
    }
    return (
      <div className="even-col__line clearfix">
        <div className="col-lg-12">
          <h2 className="space-main__headline space-main__headline-col12">動画</h2>
        </div>
        <div className="col-xs-12">
          <iframe className="space-main__video" src={SMRenderHelper.videoUrl(room.embed_video_url)} frameBorder="0" allowFullScreen={true}></iframe>
        </div>
      </div>
    );
  }

  renderPhotoList(room) {
    let rows = [null,null,null,null,null,null];
    room.thumbnails.forEach((thumb, i)=>{
      let thumb_image = SMFormatHelper.imageURLWithTransform(thumb.image,
                {width: 688, height: 688, crop: 'fill'});
      switch (i) {
        case 0:
          rows[i] = (
            <div className="col-xs-12 col-sm-6 space-main__photo-1">
              <a href="#" onClick={this.photoDidSelect.bind(this, i)}>
                <OptimizedImage src={thumb_image} alt={thumb.caption} className="w100pa is-hover"  />
              </a>
            </div>
          );
          break;
        case 1:
          rows[i] = (
            <div className="space-main__photo-2 mb8">
              <a href="#" onClick={this.photoDidSelect.bind(this, i)}>
                <OptimizedImage src={thumb_image} alt={thumb.caption} className="w100pa is-hover"  />
              </a>
            </div>
          );
          break;
        case 2:
          rows[i] = (
            <div className="space-main__photo-2">
              <a href="#" onClick={this.photoDidSelect.bind(this, i)}>
                <OptimizedImage src={thumb_image} alt={thumb.caption} className="w100pa is-hover"  />
              </a>
            </div>
          );
          break;
        case 3:
        case 4:
          rows[i] = (
            <div className="col-xs-12 col-sm-4">
              <div className="space-main__photo-3">
                <a href="#" onClick={this.photoDidSelect.bind(this, i)}>
                  <OptimizedImage src={thumb_image} alt={thumb.caption} className="w100pa is-hover"  />
                </a>
              </div>
            </div>
          );
          break;
        case 5:
          rows[i] = (
            <div className="col-xs-12 col-sm-4">
              <div className="space-main__photo-3">
                <a href="#" onClick={this.photoDidSelect.bind(this, 0)}>
                  <OptimizedImage src={thumb_image} alt={thumb.caption} className="w100pa is-hover"  />
                  <div className="space-main__photo-more">
                    <div className="space-main__photo-text">
                    <i className="fa fa-camera"></i>
                    すべての写真を見る
                    </div>
                  </div>
                </a>
              </div>
            </div>
          );
          break;
        default:
          return;
      }

    });
    return(
      <div className="col-lg-12">
        <h2 className="space-main__headline space-main__headline-col12">写真一覧</h2>
        <div className="row row-change__4 sm-hide">
          {rows[0]}
          <div className="col-xs-12 col-sm-6 sm-hide">
            {rows[1]}
            {rows[2]}
          </div>
        </div>
        <div className="row row-change__4">
          {rows[3]}
          {rows[4]}
          {rows[5]}
        </div>
      </div>
    );
  }

  renderAttachFiles(room) {
    return room.attach_files.map((attachment, index)=>{
      return (
        <p key={index}><a href={attachment.file} target="_blank" className="a__underline">{attachment.description}</a></p>
      );
    });
  }

  renderInquiryList(room) {
    let rows = [];
    if (!this.isInquiryOnly(room)) {
      rows.push(
        <li key={0}><a href={Routes.space_room_reservations_path(room.space.username, room.uid)} className="a__underline">空き状況の確認</a></li>
      );
    }
    rows.push(
      <li key={1}><a href="#" onClick={this.showInquiryForm.bind(this)} className="a__underline">スペースへのお問い合わせ</a></li>
    );
    // rows.push(
    //   <li key={2}><a href={Routes.concierge_index_path()} className="a__underline">定期利用・長期利用について（コンシェルジュサービス）</a></li>
    // );
    return rows;
  }

  renderPlanPrice(key, room, planId, priceText, unitText) {
    return(
      <a key={key} href={Routes.space_room_reservations_path(room.space.username, room.uid, {plan_id: planId})} className="button-blue space-main__plan-button">
        {priceText}
        <span className="space-main__plan-utility">{SMFormatHelper.priceUnit(unitText, true)}</span>
      </a>
    );
  }

  renderPlans(room, rentType) {
    let plans = [];
    let roomPlans = [room].concat(room.plans);
    roomPlans.forEach((plan, index)=>{
      if (rentType == SMConst.RentType.DayTime) {
        if (plan.rent_type == SMConst.RentType.Stay) {
          return false;
        }
      }
      else if (rentType == SMConst.RentType.Stay) {
        if (plan.rent_type == SMConst.RentType.DayTime) {
          return false;
        }
      }
      const name = plan.plan_name || plan.name;
      const description = (index == 0) ? plan.plan_description : plan.description;
      const planId = SMPlanHelper.isRoom(plan) ? 0 : plan.id;
      const directReservationIcon = plan.direct_reservation_accepted ?
        <span className="space-main__plan-title-note">
            <i className="fa fa-flash fa-lg space-main__plan-title-direct-icon"></i>今すぐ予約
            <span className="mod-tooltip space-main__direct-tooltip">
              <span className="baloon baloon-top mod-tooltip__detail">
                <span className="baloon-inner">ホストの承認なしに即時に予約が完了するプランです。</span>
              </span>
            </span>
        </span>
        : null;
      const lastMinuteDiscountIcon = plan.is_last_minute_discount ?
        <span className="space-main__plan-title-note">
          <i className="fa fa-lg icon-spm-discount space-main__plan-title-discount-icon"></i>直前割あり
          <span className="mod-tooltip space-main__direct-tooltip">
            <span className="baloon baloon-top mod-tooltip__detail">
              <span className="baloon-inner">利用日から5日前までの予約で割引があるプランです。</span>
            </span>
          </span>
        </span>
        : null;

      let linkButtons = [];
      if (this.isInquiryOnly(room)) {
        linkButtons.push(
          <a key={0} href="#" onClick={this.showInquiryForm.bind(this)} className="button-blue space-main__plan-button">
            {plan.min_price_text}
          </a>
        );
      } else {
        if (plan.has_session_price) {
          linkButtons.push(
            this.renderPlanPrice(0, room, planId, plan.session_price_text, plan.session_price_unit_text)
          );
        }
        if (plan.has_hourly_price) {
          linkButtons.push(
            this.renderPlanPrice(1, room, planId, plan.hourly_price_text, plan.hourly_price_unit_text)
          );
        }
        if (plan.has_daily_price) {
          linkButtons.push(
            this.renderPlanPrice(2, room, planId, plan.daily_price_text, plan.daily_price_unit_text)
          );
        }
        if (plan.has_stay_price) {
          linkButtons.push(
            this.renderPlanPrice(3, room, planId, plan.stay_price_text, plan.stay_price_unit_text)
          );
        }
      }

      plans.push(
        <div key={planId} className="space-main__plan clearfix">
          <div className="space-main__plan-title-box">
            <h3 className="space-main__plan-title">
              {name}
              {directReservationIcon}
              {lastMinuteDiscountIcon}
            </h3>
            <div className="space-main__plan-button-box">
              {linkButtons}
            </div>
          </div>
          <p className="space-main__plan-text">
            {(()=>{
              const el = SMRenderHelper.renderMinRequiredDateOrTime(plan);
              if (el != null) return (<span className="space-main__plan-rule">{el}</span>);
            })}
            {(()=>{
              const el = SMRenderHelper.renderHasRequiredFood(plan);
              if (el != null) return (<span className="space-main__plan-rule">{el}</span>);
            })}
            {description}
          </p>
        </div>
      );
    });
    return plans;
  }

  renderOptions(room) {
    let options = [];
    room.option_items.forEach((option, index)=>{
      options.push(
        <div key={index} className="space-main__plan clearfix">
          <div className="space-main__plan-title-box">
            <h3 className="space-main__plan-subtitle">{option.name}</h3>
            <div className="space-main__plan-option-box">
              <div className="space-main__plan-option">
                ＋{option.price_text}<span>/{option.price_unit_text}</span>
              </div>
            </div>
          </div>
          <p className="space-main__plan-text">{option.description}</p>
        </div>
      );
    });
    return options;
  }

  renderFoods(room) {
    let options = [];
    room.option_foods.forEach((option, index)=>{
      options.push(
        <div key={index} className="space-main__plan clearfix">
          <div className="space-main__plan-title-box">
            <h3 className="space-main__plan-subtitle">{option.name}</h3>
            <div className="space-main__plan-option-box">
              <div className="space-main__plan-option">
                ＋{option.price_text}<span>/{option.price_unit_text}</span>
              </div>
            </div>
          </div>
          <p className="space-main__plan-text">{option.description}</p>
        </div>
      );
    });
    return options;
  }

  renderRelatedEntries(room) {
    if (room.related_entries.length > 0) {
      const entry = room.related_entries[0];
      return(
        <div className="even-col__line clearfix">
          <div className="col-lg-12">
            <h2 className="space-main__headline space-main__headline-col12">利用事例</h2>
          </div>
          <div className="col-xs-12 col-sm-5">
            <a href={entry.url} target="_blank"><img src={entry.image} alt={entry.title} className="w100pa is-hover" /></a>
          </div>
          <div className="col-xs-12 col-sm-7">
            <h3 className="space-main__case-title"><a href={entry.url} target="_blank" className="a__underline">{entry.title}</a></h3>
            <p>{entry.description}</p>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  // SMCoverPhotoView delegate
  coverPhotoDidSelect(e) {
    e.preventDefault();
    this.setState({
      selectedPhotoIndex: 0,
      isSlidePhotoOpen: !this.state.isSlidePhotoOpen
    });
  }

  coverPhotoPrevDidSelect(e) {
    this.setState({
      selectedPhotoIndex: this.state.room.thumbnails.length - 1,
      isSlidePhotoOpen: true,
    });
  }

  coverPhotoNextDidSelect(e) {
    this.setState({
      selectedPhotoIndex: 1,
      isSlidePhotoOpen: true,
    });
  }

  photoDidSelect(index, e) {
    e.preventDefault();
    this.setState({
      selectedPhotoIndex: index,
      isSlidePhotoOpen: !this.state.isSlidePhotoOpen
    });
  }

  // delegate
  slidePhotoDidClose() {
    this.setState({
      isSlidePhotoOpen: false
    });
  }

  openShare(e) {
    e.preventDefault();
    this.setState({
      isOpenShare: !this.state.isOpenShare
    });
  }

  favoriteDidSelect(e){
    e.preventDefault();
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    const room = this.state.room;
    if (room.is_favorite) {
      // お気に入りに登録されている場合はモーダルを表示させる
      this.showFavoriteListSelectForm(room);
    } else {
      let responseHandler = (data, error, xhr)=>{
        if (error) {
          room.is_favorite = false;
          this.setState({
            room: room
          });
        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          room.favorites_count++;
          this.setState({
            room: room,
            latestUpdatedFavoriteList: data.favorite_list,
            isOpenDefaultFavoriteList: true,
          });
          setTimeout(()=>{
            this.setState({
              isOpenDefaultFavoriteList: false,
            });
          }, 2000);
        }
      };
      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }

  favoriteDropDownDidSelect(e) {
    e.preventDefault();
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    this.showFavoriteListSelectForm(this.state.room);
  }

  favoriteDidSelectInCarousel(favorable, isFavorite, rowIndex, tag) {
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    if (isFavorite) {
      this.showFavoriteListSelectForm(favorable);
    } else {
      let room = favorable;
      let responseHandler = (data, error, xhr) => {
        if (error) {
          room.is_favorite = false;
        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          this.setState({
            latestUpdatedFavoriteList: data.favorite_list,
          });
        }
      };
      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);

      let listItems = [];
      if (tag == this.roomTag.otherRooms) {
        listItems = this.state.room.sibling_rooms;
        listItems[rowIndex] = room;
        this.setState({otherRooms: listItems});
      } else if (tag == this.roomTag.recommendRooms) {
        listItems = this.state.areaRecommendRooms;
        listItems[rowIndex] = room;
        this.setState({areaRecommendRooms: listItems});
      } else if (tag == this.roomTag.browseRooms) {
        listItems = this.state.browseRooms;
        listItems[rowIndex] = room;
        this.setState({browseRooms: listItems});
      }
    }
  }

  showMore(refName, e) {
    e.preventDefault();
    $(this.refs[refName]).addClass("js-space-expandable__active");
  }

  showInquiry(e){
    e.preventDefault();
    this.setState({
      isInquiryViewOpen: true,
    });
  }

  toggleShareList(e){
    e.preventDefault();
    this.setState({
      isOpenShare: !this.state.isOpenShare,
    });
  }

  showInquiryForm(e){
    if (e) e.preventDefault();
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
      return;
    }
    SMUserResource.getContact(this.props.currentUser.id, (contact, error)=>{
      if (contact) {
        this.setState({
          isInquiryFormViewOpen: true,
        });
      } else {
        this.setState({
          isContactViewOpen: true,
        });
      }
    });
  }



  showFavoriteListSelectForm(room, e){
    if (e) e.preventDefault();
    this.setState({
      targetFavoriteRoom: room,
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  // request delegate
  inquiryViewDidClose() {
    this.setState({
      isInquiryViewOpen: false,
    });
  }

  inquiryFormViewDidClose() {
    this.setState({
      isInquiryFormViewOpen: false,
    });
  }

  // contact delegate
  contactViewDidClose() {
    this.setState({
      isContactViewOpen: false,
    });
  }

  contactDidCreated() {
    this.setState({
      isInquiryViewOpen: false,
      isContactViewOpen: false,
      isInquiryFormViewOpen: true,
    });
  }

  // select favorite list delegate
  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }


  detailTabClick(e) {
    e.preventDefault();
    if (this.state.selectedTabIndex == 0) {
      this.setState({selectedTabIndex: 1});
    } else {
      this.setState({selectedTabIndex: 0});
    }
  }

  setEndLocation(startLocation, sectionName) {
    if (startLocation > $(this.refs["info"]).offset().top && $(this.refs[sectionName]).offset().top == $(this.refs["info"]).offset().top) {
      if(!SMAppHelper.isMobile()){
        return $(this.refs[sectionName]).offset().top;
      } else {
        return $(this.refs[sectionName]).offset().top - 66;
      }
    } else if (startLocation < $(this.refs["info"]).offset().top && $(this.refs[sectionName]).offset().top != $(this.refs["info"]).offset().top) {
      if(!SMAppHelper.isMobile()){
        return $(this.refs[sectionName]).offset().top - 94;
      } else {
        return $(this.refs[sectionName]).offset().top - 148;
      }
    } else {
      if(!SMAppHelper.isMobile()){
        return $(this.refs[sectionName]).offset().top - 47;
      } else {
        return $(this.refs[sectionName]).offset().top - 101;
      }
    }
  }

  shortcutDidClick(sectionName, e) {
    e.preventDefault();
    let timeLapsed = 0;
    const startLocation = window.pageYOffset;
    let endLocation = this.setEndLocation(startLocation, sectionName);
    const distance = endLocation - startLocation;

    let animationInterval = setInterval(()=>{
      timeLapsed += 30;
      let percentage = (timeLapsed / parseInt(500, 10));
      percentage = (percentage > 1) ? 1 : percentage;
      const position = startLocation + (distance * percentage * percentage);
      window.scrollTo(0, Math.floor(position));
      this.stopAnimateScroll(position, endLocation, animationInterval);
    }, 16);
  }

  stopAnimateScroll(position, endLocation, animationInterval) {
    const currentLocation = window.pageYOffset;
    if ( position == endLocation || currentLocation == endLocation || ((window.innerHeight + currentLocation) >= document.body.scrollHeight )) {
      clearInterval(animationInterval);
      window.scrollTo(0 , endLocation);
    }
  }

  resize(){
    if (!SMAppHelper.isMobile()) {
      $(this.refs.spaceSide).sticky({
        topSpacing:72,
        bottomSpacing: $("body").height() - $(this.refs.stickyByBottom).offset().top + 24
      });

      $(this.refs.headerTab).sticky({
        bottomSpacing: $("body").height() - $(this.refs.stickyheaderByBottom).offset().top
      });
    }
  }

  onScroll() {
    if (!SMAppHelper.isMobile()){
      if ($(document).scrollTop() < $(this.refs["price"]).offset().top - 68) {
        this.setState({currentTab: this.scrollTab.info});
      } else if ($(document).scrollTop() >= $(this.refs["price"]).offset().top - 68 && $(document).scrollTop() < $(this.refs["review"]).offset().top - 68) {
        this.setState({currentTab: this.scrollTab.price});
      } else if ($(document).scrollTop() >= $(this.refs["review"]).offset().top - 68 && $(document).scrollTop() < $(this.refs["access"]).offset().top - 68) {
        this.setState({currentTab: this.scrollTab.review});
      } else if ($(document).scrollTop() >= $(this.refs["access"]).offset().top - 68 && $(document).scrollTop() < $(this.refs["relation"]).offset().top - 68) {
        this.setState({currentTab: this.scrollTab.access});
      } else if ($(document).scrollTop() >= $(this.refs["relation"]).offset().top - 68) {
        this.setState({currentTab: this.scrollTab.relation});
      }

      if (this.refs.usage.offsetTop < window.scrollY + window.innerHeight * 0.6) {
        this.setState({wasShownUsage: true});
      }
    } else {
      if ($(document).scrollTop() < $(this.refs["price"]).offset().top - 114) {
        this.setState({currentTab: this.scrollTab.info});
      } else if ($(document).scrollTop() >= $(this.refs["price"]).offset().top - 114 && $(document).scrollTop() < $(this.refs["review"]).offset().top - 114) {
        this.setState({currentTab: this.scrollTab.price});
      } else if ($(document).scrollTop() >= $(this.refs["review"]).offset().top - 114 && $(document).scrollTop() < $(this.refs["access"]).offset().top - 114) {
        this.setState({currentTab: this.scrollTab.review});
      } else if ($(document).scrollTop() >= $(this.refs["access"]).offset().top - 114 && $(document).scrollTop() < $(this.refs["relation"]).offset().top - 114) {
        this.setState({currentTab: this.scrollTab.access});
      } else if ($(document).scrollTop() >= $(this.refs["relation"]).offset().top - 114) {
        this.setState({currentTab: this.scrollTab.relation});
      }

      if (this.refs.usage.offsetTop < window.scrollY + (window.innerHeight - this.refs.requestButton.offsetHeight) * 0.6) {
        this.setState({wasShownUsage: true});
      }
    }
  }

  closeRoomAttentionPopup() {
    this.setState({
      isRoomAttentionPopupViewOpen: false,
    });
  }

  renderOtherRooms(room) {
    const siblingRooms = room.sibling_rooms;
    if(!siblingRooms.length) return null;
    return(
      <div className="page__even page__padding">
        <SMRoomCarouselView
          tag={this.roomTag.otherRooms}
          title={"この会場の他のスペース"}
          rooms={siblingRooms}
          noRoomImage={this.props.noRoomImage}
          delegate={this}
          latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList}
        />
      </div>
    );
  }

  renderRecommendRooms(room) {
    if(!this.state.areaRecommendRooms.length) return null;
    let rooms = [];
    this.state.areaRecommendRooms.some((room, index)=>{
      if (index >= 6) return true;
      rooms.push(room);
    });
    return (
      <div className="page__odd page__padding">
        <SMRoomCarouselView
          tag={this.roomTag.recommendRooms}
          title={"このスペース周辺の人気スペース"}
          rooms={rooms}
          noRoomImage={this.props.noRoomImage}
          delegate={this}
          latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList}
        />
      </div>
    );
  }

  renderBrowseRooms(room) {
    if (!this.state.browseRooms || !this.state.browseRooms.length) return null;
    return(
      <div className="page__even page__padding">
        <SMRoomCarouselView
          tag={this.roomTag.browseRooms}
          title={"最近チェックしたスペース"}
          rooms={this.state.browseRooms}
          noRoomImage={this.props.noRoomImage}
          delegate={this}
          latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList}
        />
      </div>
    );
  }

  renderPriceText(room) {
    let priceList = [];

    if (room.inquiry_only) return null;

    room.price_text_list.forEach(function(price, index) {
      if (price.max_price_text == null) {
        priceList.push(<p key={index}><strong>{price.min_price_text}</strong>{SMFormatHelper.priceUnit(price.min_price_unit_text, false)}</p>);
      } else {
        if (price.min_price_unit_text == null) {
          priceList.push(<p key={index}><strong>{price.min_price_text}</strong>〜<strong>{price.max_price_text}</strong>{SMFormatHelper.priceUnit(price.max_price_unit_text, false)}</p>);
        } else {
          priceList.push(<p key={index}><strong>{price.min_price_text}</strong>{SMFormatHelper.priceUnit(price.min_price_unit_text, false)}〜<strong>{price.max_price_text}</strong>{SMFormatHelper.priceUnit(price.max_price_unit_text, false)}</p>);
        }
      }
    });

    return(
      <div className="space-side__money sm-hide">
        {priceList}
        <p className="space-side__point">{SMConst.PointRate.Default}%のポイントがたまる</p>
      </div>
    );
  }

  renderPriceIconText(room) {
    const directReservationIcon = room.has_direct_reservation_plans ? <span><i className="fa fa-flash fa-lg icon-direct"></i>今すぐ予約可能なプランあり<br /></span> : null;
    const lastMinuteDiscountIcon = room.has_last_minute_discount_plans ? <span><i className="icon icon-spm-discount fa-lg icon-discount"></i>直前割対応プランあり</span> : null;

    return(
      <div className="space-side__note">
        {directReservationIcon}
        {lastMinuteDiscountIcon}
      </div>
    );
  }

  isInquiryOnly(room) {
    return (
      room.room_display_type == SMConst.RoomDisplayType.InquiryOnly ||
      room.owner.room_display_type == SMConst.RoomDisplayType.InquiryOnly
    );
  }

  renderPriceButton(room) {
    if (this.isInquiryOnly(room)) {
      return(
        <div className="space-side__request-area">
          <a ref="requestButton" href="#" onClick={this.showInquiryForm.bind(this)} className="button-blue space-side__request">{room.min_price_text}</a>
        </div>
      );
    } else {
      return(
        <div className="space-side__request-area">
          <a ref="requestButton" href={Routes.space_room_reservations_path(room.space.username, room.uid, {search_session_id: this.props.searchSessionId})} className="button-blue space-side__request">空き状況の確認／予約リクエスト</a>
        </div>
      );
    }
  }

  renderTabList() {
    let detailTab = [];
    let room = this.props.room;
    if (room.allow_rent_types && room.allow_rent_types.length <= 1) {
      return false;
    } else {
      if (room.stay_certification_status != SMConst.StayCertificationStatus.Activated || !room.has_stay_plans) return false;
      if (this.state.selectedTabIndex == 0) {
        detailTab.push(
          <li key="datetime" className="space-main__tab-rental is-current">
            <span className="space-main__tab-inner">{I18n.t('service.label_000410')}</span>
          </li>
        );
        detailTab.push(
          <li key="stay" className="space-main__tab-stay">
            <a onClick={this.detailTabClick.bind(this)} href="#">
              <span className="space-main__tab-inner">{I18n.t('service.label_000017')}</span>
            </a>
          </li>
        );
      } else {
        detailTab.push(
          <li key="datetime" className="space-main__tab-rental">
            <a onClick={this.detailTabClick.bind(this)} href="#">
              <span className="space-main__tab-inner">{I18n.t('service.label_000410')}</span>
            </a>
          </li>
        );
        detailTab.push(
          <li key="stay" className="space-main__tab-stay is-current">
              <span className="space-main__tab-inner">{I18n.t('service.label_000017')}</span>
          </li>
        );
      }
    }

    return(
      <div className="space-main__tab">
        <div className="container space-main">
          <div className="row">
            <ul className="space-main__tab-list">
              {detailTab}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  showAmenitiesNext(e) {
    e.preventDefault();
    this.setState({isOpenAmenities: true});
  }

  showAboutFoodNext(e) {
    e.preventDefault();
    this.setState({isOpenAboutFood: true});
  }

  showAboutTrashNext(e) {
    e.preventDefault();
    this.setState({isOpenAboutTrash: true});
  }

  renderAmenities(room) {
    const type = SMConst.AmenityType;
    let amenityType = (this.state.selectedTabIndex == 1) ? type.Rental : type.Stay;
    const amenityList = room.amenities.map((amenity)=>{
      return amenity.name;
    });
    const lists = this.props.amenities.map((amenity)=>{
      if (amenityType == type.Rental) {
        if (amenity.amenity_type == type.Stay) return;
      }
      else if (amenityType == type.Stay) {
        if (amenity.amenity_type == type.Rental) return;
      }
      let className = "col-xs-6 col-sm-4 col-md-4";
      let iconClassName = "icon icon-spm-" + amenity.name;
      if (amenityList.indexOf(amenity.name) == -1) {
        className += " is-none";
      }
      return (
        <li key={amenity.name} className={className}>
          <i className={iconClassName}></i>{amenity.name_text}
        </li>
      );
    });

    if (this.state.isOpenAmenities) {
      return (
        <ul className="row">
          {lists}
        </ul>
      );
    } else {
      return (
        <div className="space-expandable">
          <div className="space-expandable__area">
            <div className="space-expandable__area-text">
              <ul className="row">
                {lists}
              </ul>
            </div>
            <div className="space-expandable__continue"></div>
            <p className="space-expandable__link"><a href="#showAmenitiesNext" onClick={this.showAmenitiesNext.bind(this)} className="a__underline">続きを読む</a></p>
          </div>
        </div>
      );
    }
  }

  renderAboutFood(room) {
    const description = SMFormatHelper.description(room.food_description);
    if (!room.food_description || this.state.isOpenAboutFood) {
      return (
        <p dangerouslySetInnerHTML={{__html:description}} />
      );
    } else {
      return (
        <div className="space-expandable">
          <div className="space-expandable__area">
            <div className="space-expandable__area-text">
              <p dangerouslySetInnerHTML={{__html:description}} />
            </div>
            <div className="space-expandable__continue"></div>
            <p className="space-expandable__link"><a href="#showAboutFoodNext" onClick={this.showAboutFoodNext.bind(this)} className="a__underline">続きを読む</a></p>
          </div>
        </div>
      );
    }
  }

  renderAboutTrash(room) {
    const description = SMFormatHelper.description(room.trash_description);
    if (!room.trash_description || this.state.isOpenAboutTrash) {
      return (
        <p dangerouslySetInnerHTML={{__html:description}} />
      );
    } else {
      return (
        <div className="space-expandable">
          <div className="space-expandable__area">
            <div className="space-expandable__area-text">
              <p dangerouslySetInnerHTML={{__html:description}} />
            </div>
            <div className="space-expandable__continue"></div>
            <p className="space-expandable__link"><a href="#showAboutTrashNext" onClick={this.showAboutTrashNext.bind(this)} className="a__underline">続きを読む</a></p>
          </div>
        </div>
      );
    }
  }

  renderStayRoomType(room) {
    if (this.state.selectedTabIndex != 1) {
      return false;
    }

    let stayRoomType = "";
    if (room.stay_room_type == SMConst.StayRoomType.SharedRoom) {
      stayRoomType = I18n.t('service.label_000412');
    } else if (room.stay_room_type == SMConst.StayRoomType.PrivateRoom) {
      stayRoomType = I18n.t('service.label_000413');
    } else if (room.stay_room_type == SMConst.StayRoomType.EntirePlace) {
      stayRoomType = I18n.t('service.label_000414');
    }

    return(
      <div className="even-col__line clearfix">
        <div className="col-sm-12 col-md-3 col-lg-2">
          <h2 className="space-main__headline">{I18n.t('service.label_000415')}</h2>
        </div>
        <div className="col-sm-12 col-md-9 col-lg-10">
          <p>{stayRoomType}</p>
        </div>
      </div>
    );
  }

  renderRoomUsage(roomUsageRates) {
    const barGraphClassName = this.state.wasShownUsage ? 'js-space-main__usage-graph-content space-main__usage-graph-content' : 'space-main__usage-graph-content';

    const items = roomUsageRates.map((usage) => {
      const rate = Math.round(usage.rate);
      const barStyle = this.state.wasShownUsage ? { width: rate + '%'} : {};
      const eventTypeText = usage.event_type_text;
      return (
        <li className="space-main__usage-list">
          <p className="space-main__usage-name">{eventTypeText}</p>
          <p className="space-main__usage-graph">
            <span className={barGraphClassName} style={barStyle}>
            </span>
          </p>
          <p className="space-main__usage-per">{rate}％</p>
        </li>
      );
    });

    return(
      <div className="col-sm-12 col-md-8">
        <h2 className="page-subtitle">このスペースはこんな用途で使われています</h2>
        <ul>
          {items}
        </ul>
      </div>
    );
  }

  renderRoomAttentionPopup() {
    let attentionWeeklyGuests = this.state.attentionWeeklyGuests;
    if (!this.state.isRoomAttentionPopupViewOpen || !attentionWeeklyGuests > 0) return;
    return(
      <div className="space-main__attention">
        <ul className="fa-ul">
          <li><i className="fa fa-lg fa-clock-o fa-li space-main__attention-icon"></i>最近1週間で<span className="space-main__attention-number">{attentionWeeklyGuests}</span>人がこのスペースを利用しました。</li>
        </ul>
        <p className="space-main__attention-close"><a href="#" onClick={this.closeRoomAttentionPopup.bind(this)}><i className="fa fa-times"></i></a></p>
      </div>
    );
  }

  render() {

    const room = this.state.room;
    const space = room.space;
    const owner = room.owner;

    let coverImageUrl = this.props.noRoomImage;
    if (room.thumbnails.length > 0) {
      coverImageUrl = room.thumbnails[0].image;
      if (!SMAppHelper.isMobile()) {
        coverImageUrl = SMFormatHelper.imageURLWithTransform(coverImageUrl,
                  {width: 1200, height: 670, crop: 'fill'});
      }
    }
    const googleMapUrl = sprintf("https://www.google.com/maps?q=%s,%s+(%s)",
      space.latitude,
      space.longitude,
      encodeURIComponent(space.name)
    );

    let eventTypeNames = [];

    room.event_types.forEach((eventType)=>{
      eventTypeNames.push(eventType.name_text);
    });

    const favClassName = room.is_favorite ? "space-side__buttons-fav__on" : "";
    const favClassNameCaretDown = room.is_favorite > 0 ? 'space-side-fa_buttons-select-on' : '';

    let optionStyle = {};
    if (room.option_items.length == 0 && room.option_foods.length == 0) {
      optionStyle["display"] = "none";
    }
    const shareStyle = this.state.isOpenShare ? {} : {display: "none"};

    let favCount = null;
    if (room.favorites_count > 999) favCount = sprintf('(999+)');
    if (room.favorites_count > 0) favCount = sprintf('(%d)', room.favorites_count);

    const roomDescriptionMoreStyle = this.state.isShowRoomDescriptionMore ? {} : {display: "none"};
    const spaceDescriptionMoreStyle = this.state.isShowSpaceDescriptionMore ? {} : {display: "none"};

    let capacity = null;
    if (this.state.selectedTabIndex == 0) {
      capacity = SMFormatHelper.capacity(room);
    } else if (this.state.selectedTabIndex == 1) {
      capacity = "〜" + room.stay_capacity.toString() + "人" ;
    }

    let plans = null;
    if (this.state.selectedTabIndex == 0) {
      plans = this.renderPlans(room, SMConst.RentType.DayTime);
    } else if (this.state.selectedTabIndex == 1) {
      plans = this.renderPlans(room, SMConst.RentType.Stay);
    }

    let goldSuperHost = null;
    if (owner.rank == SMConst.OwnerRank.SuperHost) {
      goldSuperHost = <img src={SMRailsBridge.assetPath.goldSuperHost} alt="トップホスト" className="space-side__owner-superhost" />;
    }

    const evaluateConfirmRate = SMOwnerHelper.ownerEvaluationImage(owner.confirm_rate_evaluation);
    const evaluateReplyRate = SMOwnerHelper.ownerEvaluationImage(owner.reply_rate_evaluation);
    const evaluateReplyTimeAvg = SMOwnerHelper.ownerEvaluationImage(owner.reply_time_avg_evaluation);

    const latestUpdatedFavoriteListPopup = [];
    if (this.state.isOpenDefaultFavoriteList && Object.keys(this.state.latestUpdatedFavoriteList).length !== 0) {
      latestUpdatedFavoriteListPopup.push(
        <div className="space-side__favorite">
          <div className="space-side__favorite-baloon">
            <p className="space-side__favorite-baloon-text">{this.state.latestUpdatedFavoriteList.name}</p>
          </div>
        </div>
      );
    }

    const roomUsageRates = room.usage_rates;

    return(
      <div className="site-main" itemScope itemType="http://schema.org/LodgingBusiness">
        <SMSlidePhotoView
          selectedPhotoIndex={this.state.selectedPhotoIndex}
          room={room}
          isOpen={this.state.isSlidePhotoOpen}
          delegate={this} />
        <SMCoverPhotoView room={room} source={coverImageUrl} delegate={this} />
        <div className="space-head__shortcut-tab" ref="headerTab">
          <div className="container">
            <ul>
              <li className={`space-head__shortcut-tab-list ${(this.state.currentTab == this.scrollTab.info) ? ' space-head__shortcut-tab-list-current' : ''}`}><a onClick={this.shortcutDidClick.bind(this, "info")} href="#">概要</a></li>
              <li className={`space-head__shortcut-tab-list ${(this.state.currentTab == this.scrollTab.price) ? ' space-head__shortcut-tab-list-current' : ''}`}><a onClick={this.shortcutDidClick.bind(this, "price")} href="#">価格</a></li>
              <li className={`space-head__shortcut-tab-list ${(this.state.currentTab == this.scrollTab.review) ? ' space-head__shortcut-tab-list-current' : ''}`}><a onClick={this.shortcutDidClick.bind(this, "review")} href="#">レビュー</a></li>
              <li className={`space-head__shortcut-tab-list ${(this.state.currentTab == this.scrollTab.access) ? ' space-head__shortcut-tab-list-current' : ''}`}><a onClick={this.shortcutDidClick.bind(this, "access")} href="#">アクセス</a></li>
              <li className={`space-head__shortcut-tab-list ${(this.state.currentTab == this.scrollTab.relation) ? ' space-head__shortcut-tab-list-current' : ''}`}><a onClick={this.shortcutDidClick.bind(this, "relation")} href="#">関連</a></li>
            </ul>
          </div>
        </div>
        <div ref="info"></div>
        <div className="page__odd space-head">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <h1 className="space-head__title" itemProp="name">{SMFormatHelper.roomName(room)}</h1>
                <ul className="space-head__list link__subcolor">
                  <li className="space-head__list-star">
                    <a href={Routes.reputations_space_room_path(room.space.username, room.uid)}>{SMRenderHelper.renderReviewStars(room.reputation_score)}</a>
                    <a href={Routes.reputations_space_room_path(room.space.username, room.uid)} className="space-head__list-number">{room.reputation_count}件</a>
                  </li>
                  <li className="space-head__list-place"><span className="space-head__list-place-text"><i className="fa fa-building mr5"></i><a href={Routes.space_path(space.username)}>{SMFormatHelper.spaceName(space)}</a></span></li>
                  <li className="space-head__list-user"><i className="fa fa-user mr5"></i><a href={`/capacities/${room.capacity}`}>{SMFormatHelper.capacity(room)}</a></li>
                  <li className="space-head__list-map"><i className="fa fa-map-marker mr5"></i><a href={`/areas/${space.state}/location/${space.city}`}>{space.state_text}{space.city}</a></li>
                  <li className="space-head__list-map"><i className="fa fa-folder mr5"></i><a href={`/space_types/${space.space_type}`}>{space.space_type_text}</a></li>
                </ul>
              </div>
              <div className="col-sm-12 col-md-4 side-fixed">
                <div ref="spaceSide" className="space-side">
                  <div className="space-side__box clearfix">
                    {this.renderPriceText(room)}
                    {this.renderPriceIconText(room)}
                    {this.renderPriceButton(room)}
                    <ul className="space-side__buttons clearfix">
                     <li className={favClassName}>
                        <div className="space-side__buttons-list">
                          <a href="#" onClick={this.favoriteDidSelect.bind(this)} className="space-side__buttons-favorite"><i className="fa fa-heart"></i>{I18n.t('service.label_000051')}<span className="space-side__buttons-fav__count">{favCount}</span></a>
                          <CSSTransitionGroup transitionName="js-favoritelist-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                            {latestUpdatedFavoriteListPopup}
                          </CSSTransitionGroup>
                        </div>
                      </li>
                      <li className="space-side__buttons-fav__select">
                        <div className="space-side__buttons-list">
                          <a href="#" onClick={this.favoriteDropDownDidSelect.bind(this)} className={"space-side__buttons-select "+favClassNameCaretDown}><i className="fa fa-caret-down"></i></a>
                        </div>
                      </li>
                      <li className="space-side__buttons-share">
                        <div className="space-side__buttons-list">
                          <a href="#" onClick={this.toggleShareList.bind(this)} className="space-side__button-share"><i className="fa fa-share-alt"></i>シェア</a>
                          <div style={shareStyle} className="space-side__share-tooltip">
                            <div className="baloon baloon-top space-side__share-baloon">
                              <div className="baloon-inner">
                                <ul className="space-side__social link__subcolor">
                                  <li><a href={this.state.twitterUrl} target="_blank"><i className="fa fa-twitter"></i>Twitter</a></li>
                                  <li><a href={this.state.fbUrl} target="_blank"><i className="fa fa-facebook-square"></i>Facebook</a></li>
                                  <li><a href={this.state.lineUrl} target="_blank"><i className="icon-spm-line"></i>LINE</a></li>
                                  <li><a ref="urlCopy" data-clipboard-text={this.state.copyUrl} aria-label="" className="hint--medium hint--bottom hint--rounded url-copy-link" onClick={(e)=>{ e.preventDefault(); }} ><i className="fa fa-link"></i>URLをコピー</a></li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="space-side__box clearfix">
                    <div className="space-side__owner-area">
                      <div className="mod-host__icon-inner">
                        <a href={Routes.owner_path(owner.username)}>
                          <img src={owner.profile_image} alt={SMFormatHelper.ownerName(owner)} className="is-hover space-side__owner-icon" />
                        </a>
                        {goldSuperHost}
                      </div>
                      <h2 className="space-side__owner-title">このスペースの管理者</h2>
                      <h3 className="space-side__owner-name link__subcolor" itemProp="legalName"><a href={Routes.owner_path(owner.username)}>{SMFormatHelper.ownerName(owner)}</a></h3>
                      <p className="space-side__owner-contact"><a href="#" onClick={this.showInquiryForm.bind(this)} className="a__underline">メッセージを送る</a></p>
                      <div className="space-side__owner-eval">
                        <div className="space-side__owner-eval-innner row">
                          <div className="space-side__owner-eval-innner-list col-xs-4">
                            <h4 className="mod-evaluate__title">{I18n.t("service.label_000058")}
                              <span className="mod-evaluate__help">
                                <i className="fa fa-question-circle mod-evaluate__question"></i>
                                <span className="mod-tooltip mod-evaluate__help-tooltip">
                                  <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                                    <span className="baloon-inner">予約リクエストが承認された実績等を元に、スペースマーケットが算出した表記です。</span>
                                  </span>
                                </span>
                              </span>
                            </h4>
                            <div className="mod-evaluate__value">
                              <img src={evaluateConfirmRate} alt="" className="mod-evaluate__value-img" />
                              <span className="mod-evaluate__value-text">{owner.confirm_rate_text}</span>
                            </div>
                          </div>
                          <div className="space-side__owner-eval-innner-list col-xs-4">
                            <h4 className="mod-evaluate__title">{I18n.t("service.label_000006")}</h4>
                            <div className="mod-evaluate__value">
                              <img src={evaluateReplyRate} alt="" className="mod-evaluate__value-img" />
                              <span className="mod-evaluate__value-text">{owner.reply_rate_text}</span>
                            </div>
                          </div>
                          <div className="space-side__owner-eval-innner-list col-xs-4">
                            <h4 className="mod-evaluate__title">{I18n.t("service.label_000007")}</h4>
                            <div className="mod-evaluate__value">
                              <img src={evaluateReplyTimeAvg} alt="" className="mod-evaluate__value-img" />
                              <span className="mod-evaluate__value-text">{owner.reply_time_avg_text}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page__even page__space-detail">
          <div className="container space-main">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <div className="row">
                  <div className="even-col__line clearfix bg-n">
                    <div className="col-sm-12 col-md-3 col-lg-2">
                      <h2 className="space-main__headline">会場について</h2>
                    </div>
                    <div className="col-sm-12 col-md-9 col-lg-10" itemProp="description">
                      <div ref="spaceDescription" className="space-expandable">
                        <div ref="spaceExpandableArea" className="space-expandable__area">
                          <div ref="spaceExpandableAreaText" className="space-expandable__area-text">
                            <p dangerouslySetInnerHTML={{__html:SMFormatHelper.description(space.description)}} />
                          </div>
                          <div style={spaceDescriptionMoreStyle} className="space-expandable__continue"></div>
                        </div>
                        <p style={spaceDescriptionMoreStyle} className="space-expandable__link"><a onClick={this.showMore.bind(this, "spaceDescription")} href="#" className="a__underline">{I18n.t("service.label_000018")}</a></p>
                      </div>
                    </div>
                  </div>
                  <div className="even-col__line clearfix">
                    <div className="col-sm-12 col-md-3 col-lg-2">
                      <h2 className="space-main__headline">設備・サービス</h2>
                    </div>
                    <div className="col-sm-12 col-md-9 col-lg-10">
                      <div ref="roomDescription" className="space-expandable">
                        <div ref="roomExpandableArea" className="space-expandable__area">
                          <div ref="roomExpandableAreaText" className="space-expandable__area-text">
                            <p dangerouslySetInnerHTML={{__html:SMFormatHelper.description(room.description)}} />
                          </div>
                          <div style={roomDescriptionMoreStyle} className="space-expandable__continue"></div>
                        </div>
                        <p style={roomDescriptionMoreStyle} className="space-expandable__link"><a onClick={this.showMore.bind(this, "roomDescription")} href="#" className="a__underline">{I18n.t("service.label_000018")}</a></p>
                      </div>
                    </div>
                  </div>
                  <div className="even-col__line clearfix">
                    <div className="col-sm-12 col-md-3 col-lg-2">
                      <h2 className="space-main__headline">利用可能な用途</h2>
                    </div>
                    <div className="col-sm-12 col-md-9 space-main__amenity">
                      <ul className="row">
                        {room.event_types.map((eventType)=>{
                          return (
                            <li key={eventType.name} className="col-xs-6 col-sm-4 col-md-4"><a href={`/event_types/${eventType.name}`}>{eventType.name_text}</a></li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                  <div className="container space-main">
                    <div className="row">
                      <div className="col-sm-12 col-md-8">
                        <div className="row">
                          <div className="even-col__line clearfix">
                            <div className="col-sm-12 col-md-3 col-lg-2">
                              <h2 className="space-main__headline">広さ</h2>
                            </div>
                            <div className="col-sm-12 col-md-9 col-lg-10">
                              <p>{SMFormatHelper.area(room)}</p>
                            </div>
                          </div>
                          <div className="even-col__line clearfix">
                            <div className="col-sm-12 col-md-3 col-lg-2">
                              <h2 className="space-main__headline">収容人数</h2>
                            </div>
                            <div className="col-sm-12 col-md-9 col-lg-10">
                              <p>{capacity}</p>
                            </div>
                          </div>
                          <div className="even-col__line clearfix">
                            <div className="col-sm-12 col-md-3 col-lg-2">
                              <h2 className="space-main__headline">営業時間</h2>
                            </div>
                            <div className="col-sm-12 col-md-9 col-lg-10">
                              <p dangerouslySetInnerHTML={{__html:SMFormatHelper.description(room.business_hours_text)}} />
                              {room.room_extra_business_hours_text.map(function(text, index) {
                                return <p key={index} dangerouslySetInnerHTML={{__html:SMFormatHelper.description(text)}} />;
                              })}
                            </div>
                          </div>
                          <div className="even-col__line clearfix">
                            <div className="col-sm-12 col-md-3 col-lg-2">
                              <h2 className="space-main__headline">添付ファイル</h2>
                            </div>
                            <div className="col-sm-12 col-md-9 col-lg-10">
                              {this.renderAttachFiles(room)}
                            </div>
                          </div>
                          <div className="even-col__line clearfix">
                            <div className="col-sm-12 col-md-3 col-lg-2">
                              <h2 className="space-main__headline">お支払い方法</h2>
                            </div>
                            <div className="col-sm-12 col-md-9 col-lg-10">
                            <ul>
                              <li>クレジットカード<i className="fa fa-cc-visa fa-lg ml5 payment-card__visa"></i><i className="fa fa-cc-mastercard fa-lg ml5 payment-card__master"></i><i className="fa fa-cc-amex fa-lg ml5 payment-card__amex"></i></li>
                              <li>銀行振込(後払い)<span className="space-main__payment-attention">※法人利用のみ</span></li>
                            </ul>
                            <p><a href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.PaymentMethod)} target="_blank" className="a__underline">もっと詳しく</a></p>
                            </div>
                          </div>
                          <div className="even-col__line clearfix">
                            <div className="col-sm-12 col-md-3 col-lg-2">
                              <h2 className="space-main__headline">注意事項</h2>
                            </div>
                            <div className="col-sm-12 col-md-9 col-lg-10">
                              <ul>
                                <li><a href={SMAppHelper.policyUrl(room)} target="_blank" className="a__underline">キャンセルポリシー</a></li>
                                <li><a href={SMAppHelper.termsUrl(room)} target="_blank" className="a__underline">ゲスト規約</a></li>
                                <li><a href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.IssueInvoice)} target="_blank" className="a__underline">請求書について</a></li>
                              </ul>
                            </div>
                          </div>
                          <div className="even-col__line clearfix">
                            <div className="col-sm-12 col-md-3 col-lg-2">
                              <h2 className="space-main__headline">お問い合わせ</h2>
                            </div>
                            <div className="col-sm-12 col-md-9 col-lg-10">
                              <ul>
                                {this.renderInquiryList(room)}
                              </ul>
                            </div>
                          </div>
                          {this.renderRelatedEntries(room)}
                          <div className="even-col__line clearfix">
                            {this.renderPhotoList(room)}
                          </div>
                          {this.renderVr(room)}
                          {this.renderVideo(room)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.renderTabList()}
          <div className="space-main__tab-inside">
            <div className="container space-main">
              <div className="row">
                <div className="col-sm-12 col-md-8">
                  <div className="row">
                    <div className="even-col__line clearfix">
                      <div className="col-sm-12 col-md-3 col-lg-2">
                        <h2 className="space-main__headline">アメニティ</h2>
                      </div>
                      <div className="col-sm-12 col-md-9 space-main__amenity">
                        {this.renderAmenities(room)}
                      </div>
                    </div>
                    {this.renderStayRoomType(room)}
                    <div className="even-col__line clearfix">
                      <div className="col-sm-12 col-md-3 col-lg-2">
                        <h2 className="space-main__headline">飲食について</h2>
                      </div>
                      <div className="col-sm-12 col-md-9 col-lg-10">
                        {this.renderAboutFood(room)}
                      </div>
                    </div>
                    <div className="even-col__line clearfix">
                      <div className="col-sm-12 col-md-3 col-lg-2">
                        <h2 className="space-main__headline">後片付け・<br className="sm-hide" />ゴミについて</h2>
                      </div>
                      <div className="col-sm-12 col-md-9 col-lg-10">
                        {this.renderAboutTrash(room)}
                      </div>
                    </div>
                    <div ref="price"></div>
                    <div className="even-col__line clearfix">
                      <div className="col-sm-12 col-md-3 col-lg-2">
                        <h2 className="space-main__headline">価格</h2>
                      </div>
                      <div className="col-sm-12 col-md-9 col-lg-10">
                        {plans}
                      </div>
                    </div>
                    <div style={optionStyle} className="even-col__line clearfix">
                      <div className="col-sm-12 col-md-3 col-lg-2">
                        <h2 className="space-main__headline">追加料金<br className="sm-hide" />(オプション)</h2>
                      </div>
                      <div style={optionStyle} className="col-sm-12 col-md-9 col-lg-10">
                        <h3 style={SMRenderHelper.hideIfEmpty(room.option_items)} className="space-main__plan-title">設備・サービス</h3>
                        {this.renderOptions(room)}
                        <h3 style={SMRenderHelper.hideIfEmpty(room.option_foods)} className="space-main__plan-title">飲食</h3>
                        {this.renderFoods(room)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref="usage"></div>
        {(() => {
          if (roomUsageRates.length > 0) {
            return(
              <div className="page__odd page__padding">
                <div className="container">
                  <div className="row mod-review">
                    {this.renderRoomUsage(roomUsageRates)}
                  </div>
                </div>
              </div>
            );
          }
        })()}

        <div ref="review"></div>
        <div className="page__even page__padding">
          <div className="container">
            <div className="row mod-review">
              <div className="col-sm-12 col-md-8">
                <h2 className="page-subtitle">評価とレビュー</h2>
                <ul className="mod-review__head" itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
                  <li className="mod-review__head-star">
                    <a href={Routes.reputations_space_room_path(room.space.username, room.uid)}>{SMRenderHelper.renderReviewStars(room.reputation_score)}</a>
                  </li>
                  <li className="mod-review__head-rating" itemProp="ratingValue">{room.reputation_score}</li>
                  <li itemProp="reviewCount">
                    <a href={Routes.reputations_space_room_path(room.space.username, room.uid)} className="space-head__list-number">{room.reputation_count}件</a>
                  </li>
                </ul>
                <SMReputationListView reputated="Room" reputations={room.reputations} />
                <div className="mod-more__link">
                  <a href={Routes.reputations_space_room_path(room.space.username, room.uid)} className="button-blue pt13 pb13 w200">レビューをもっと見る</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page__odd page__padding">
          <div className="container">
            <div className="row">
              <SMOwnerSummaryView owner={owner} delegate={this} canInquiry={false} />
            </div>
          </div>
        </div>
        <div ref="access"></div>

        <div ref="stickyByBottom" className="space-main__map">
          <SMSpaceMapView space={space} hasInfoWindow={true} />
        </div>
        <div className="page__odd space-main__access">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-9">
                <h2 className="space-main__access-title">住所</h2>
                <p itemProp="address" itemScope itemType="http://schema.org/PostalAddress" className="space-main__access-content"><span itemProp="addressRegion">{space.state_text}</span><span itemProp="addressLocality">{space.city}</span><span itemProp="streetAddress">{space.address_1} {space.address_2}</span></p>
                <h2 className="space-main__access-title">アクセス</h2>
                <p className="space-main__access-content" dangerouslySetInnerHTML={{__html:SMFormatHelper.description(space.access)}} />
              </div>
              <div className="col-sm-12 col-md-3">
                <a href={googleMapUrl} target="_blank" className="button-blue pt13 pb13 w200 space-main__access-googlemap">Google Mapで見る</a>
              </div>
            </div>
          </div>
        </div>
        <div ref="relation"></div>
        {this.renderOtherRooms(room)}
        {this.renderRecommendRooms(room)}
        {this.renderBrowseRooms(room)}
        <CSSTransitionGroup transitionName="js-room-attention-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          {this.renderRoomAttentionPopup()}
        </CSSTransitionGroup>
        <SMRoomInquiryView
          delegate={this}
          currentUser={this.props.currentUser}
          room={this.state.room}
          isOpen={this.state.isInquiryViewOpen} />
        <SMRoomInquiryFormView
          delegate={this}
          currentUser={this.props.currentUser}
          room={this.state.room}
          isOpen={this.state.isInquiryFormViewOpen} />
        <SMUserContactView
          delegate={this}
          currentUser={this.props.currentUser}
          isOpen={this.state.isContactViewOpen} />
        <SMUFavoriteListSelectView
          room={this.state.targetFavoriteRoom}
          delegate={this}
          user={this.props.currentUser}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          noFavoriteListImage={this.props.noFavoriteListImage} />
        <div ref="stickyheaderByBottom">
        </div>
      </div>
    );
  }

}
export default SMRoomView;



// WEBPACK FOOTER //
// ./app/javascript/components/rooms/SMRoomView.jsx